import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const HeartIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 14"
  >
    <path d="M14.325 1.01C12.519-.51 9.728-.282 8 1.477 6.272-.282 3.481-.512 1.675 1.01c-2.35 1.978-2.006 5.203-.331 6.913l5.481 5.584a1.64 1.64 0 0 0 2.35.003l5.481-5.584c1.672-1.71 2.022-4.934-.331-6.916m-.737 5.859-5.482 5.584c-.075.075-.137.075-.212 0L2.413 6.87c-1.141-1.163-1.372-3.363.228-4.71 1.215-1.022 3.09-.868 4.265.328L8 3.603l1.094-1.116c1.181-1.203 3.056-1.35 4.265-.33 1.597 1.346 1.36 3.559.229 4.712" />
  </svg>
);
HeartIcon.id = 'HeartIcon';
HeartIcon.displayName = 'HeartIcon';
export default HeartIcon;
